import React, { useState, useRef } from 'react';
import { Menu, ActionIcon, TextInput, Text, ScrollArea } from '@mantine/core';
import { IconHash } from '@tabler/icons-react';

const TokenSelector = ({ value, onChange, availableFields = [], placeholder = "Value" }) => {
  const [menuOpened, setMenuOpened] = useState(false);
  const [search, setSearch] = useState('');
  const inputRef = useRef(null);
  
  // Filter fields based on search
  const filteredFields = availableFields.filter(field => 
    field.toLowerCase().includes(search.toLowerCase())
  );
  
  const handleTokenSelect = (field) => {
    const cursorPos = inputRef.current?.selectionStart || value.length;
    const newValue = value.slice(0, cursorPos) + `<${field}>` + value.slice(cursorPos);
    onChange(newValue);
    setMenuOpened(false);
    setSearch('');
    
    // Set cursor position after the inserted token
    setTimeout(() => {
      if (inputRef.current) {
        const newPos = cursorPos + field.length + 2; // +2 for < and >
        inputRef.current.setSelectionRange(newPos, newPos);
        inputRef.current.focus();
      }
    }, 0);
  };
  
  return (
    <div className="relative flex items-center">
      <TextInput
        ref={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1"
        rightSection={
          <Menu
            opened={menuOpened}
            onChange={setMenuOpened}
            position="bottom-end"
            withinPortal
            width={250}
          >
            <Menu.Target>
              <ActionIcon
                variant="subtle"
                color="blue"
                onClick={() => setMenuOpened(!menuOpened)}
                title="Insert token"
              >
                <IconHash size={16} />
              </ActionIcon>
            </Menu.Target>
            
            <Menu.Dropdown>
              <div className="p-2">
                <TextInput
                  placeholder="Search fields..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  size="xs"
                  autoFocus
                />
              </div>
              
              <ScrollArea style={{ maxHeight: 300 }}>
                {filteredFields.length === 0 ? (
                  <Text size="sm" color="dimmed" className="p-2">
                    No fields found
                  </Text>
                ) : (
                  filteredFields.map((field) => (
                    <Menu.Item
                      key={field}
                      onClick={() => handleTokenSelect(field)}
                    >
                      <div className="flex items-center gap-2">
                        <code className="text-xs bg-gray-100 px-1 rounded">
                          &lt;{field}&gt;
                        </code>
                        <Text size="xs" color="dimmed">
                          {field.split('.').pop()}
                        </Text>
                      </div>
                    </Menu.Item>
                  ))
                )}
              </ScrollArea>
            </Menu.Dropdown>
          </Menu>
        }
      />
    </div>
  );
};

export default TokenSelector;